export default __webpack_public_path__ + "static/media/chaya.4762b9ac.jpeg";